import React from 'react'
import { Link } from "react-router-dom"

function RelatedCard({ item, className }) {
    return (
        <Link to={`/${item.categoryName}/${item.id}`}>
            <div className="card card-compact bg-base-100 w-[13rem] shadow-xl hover:scale-105 transition-transform duration-300 ease-in-out h-[360px]">
                <figure style={{alignItems: "normal"}}>
                    <img
                        src={item.imageLinks.length === 0 ? '' : item.imageLinks[0].imageLink}
                        alt="Related Product" />
                </figure>
                <div className="card-body">
                    <h2 className="card-title">{item.title}</h2>
                    <p className="font-bold text-base">{item.discountedPrice ? <><span className='mr-4 text-orange-600 text-xl'>{item.discountedPrice} ден</span><span className='line-through font-semibold'>{item.price} ден</span> </> : <span className='mr-4 text-myYellow text-xl'>{item.price} ден</span>}</p>
                    <div className="card-actions justify-end">
                        <button className="btn btn-primary">Види</button>
                    </div>
                </div>
            </div>
        </Link>
    )
}

export default RelatedCard
